import { render, staticRenderFns } from "./RelatorioAdm.vue?vue&type=template&id=de92fd72&"
import script from "./RelatorioAdm.vue?vue&type=script&lang=js&"
export * from "./RelatorioAdm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports